// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
}
.popup-main {
  /* width: 40vw;

  position: absolute;

  margin-left: 300px;
  height: auto;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center; */

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex
;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.popcenter {
  height: 90%;
  width: 85%;
  /* / background-color: blueviolet; / */

  float: right;
}
.crossIcon {
  display: flex;
  width: 490px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Request/ApplyRequests/RepairOfAsset/RepairOfAsset.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;AACA;EACE;;;;;;;;;wBASsB;;EAEtB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B;AACF;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,WAAW;EACX,UAAU;EACV,sCAAsC;;EAEtC,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd","sourcesContent":["* {\n  margin: 0;\n}\n.popup-main {\n  /* width: 40vw;\n\n  position: absolute;\n\n  margin-left: 300px;\n  height: auto;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center; */\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex\n;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n.popcenter {\n  height: 90%;\n  width: 85%;\n  /* / background-color: blueviolet; / */\n\n  float: right;\n}\n.crossIcon {\n  display: flex;\n  width: 490px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
